/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react'
import {initialQueryState, KTIcon, useDebounce} from '../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {cpfMask} from '../../../../../utils/cpfMask'
import {phoneMask} from '../../../../../utils/phoneMask'
import {cleanMask} from '../../../../../utils/cleanMask'

const ListSearchComponent = () => {
  const {updateState} = useQueryRequest()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [document, setDocument] = useState<string>('')
  const [phone, setPhone] = useState<string>('')

  // Debounce para só chamar a API quando o usuário parar de digitar
  const debouncedSearchTerm = useDebounce(searchTerm, 300)
  const debouncedDocument = useDebounce(document, 300)
  const debouncedPhone = useDebounce(phone, 300)

  useEffect(() => {
    if (debouncedSearchTerm !== undefined) {
      updateState({name: debouncedSearchTerm, ...initialQueryState})
    }
  }, [debouncedSearchTerm])

  useEffect(() => {
    if (debouncedDocument !== undefined) {
      updateState({document: cleanMask(debouncedDocument), ...initialQueryState})
    }
  }, [debouncedDocument])

  useEffect(() => {
    if (debouncedPhone !== undefined) {
      updateState({phone: cleanMask(debouncedPhone), ...initialQueryState})
    }
  }, [debouncedPhone])

  return (
    <div className='card-title flex-wrap'>
      {/* begin::Search */}
      <div className='d-flex flex-wrap align-items-center position-relative my-1 gap-4'>
        <div className='position-relative'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute top-50 translate-middle-y ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='name'
            className='form-control form-control-solid w-250px ps-14'
            placeholder='Pesquisar usuário'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <input
          type='text'
          data-kt-user-table-filter='document'
          className='form-control form-control-solid w-175px'
          placeholder='CPF'
          maxLength={14}
          value={document}
          onChange={(e) => setDocument(cpfMask(e.target.value))}
        />
        <input
          type='text'
          data-kt-user-table-filter='phone'
          className='form-control form-control-solid w-175px'
          placeholder='Telefone'
          maxLength={15}
          value={phone}
          onChange={(e) => setPhone(phoneMask(e.target.value))}
        />
        <select
          className='form-select form-select-solid w-175px'
          aria-label='Filtrar por status'
          data-kt-user-table-filter='active'
          onChange={(e) => updateState({active: e.target.value, ...initialQueryState})}
        >
          <option value=''>Todos os status</option>
          <option value='1'>Ativo</option>
          <option value='0'>Inativo</option>
        </select>
      </div>
      {/* end::Search */}
    </div>
  )
}

export {ListSearchComponent}
